import { StepperStep } from "@/components/Stepper";
import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { TFunction } from "i18next";

export const getStepper = ({
  currentAction,
  isOutOfTimeChrono,
  translator,
}: {
  currentAction: ModuleCommandEnum;
  isOutOfTimeChrono: boolean;
  translator: TFunction;
}) => {
  const result: StepperStep[] = [];

  const UP = (): StepperStep[] => [
    {
      label: translator("action.up"),
      status: isOutOfTimeChrono ? "completed" : "active",
      image: "up",
    },
    {
      label: translator("action.open"),
      status: "pending",
      image: "unfolded",
    },
    {
      label: translator("modulesStatesShort.unfolded"),
      status: "pending",
      image: "valid",
    },
  ];

  const OPEN = (): StepperStep[] => [
    {
      label: translator("action.up"),
      status: "completed",
      image: "up",
    },
    {
      label: translator("action.open"),
      status: isOutOfTimeChrono ? "completed" : "active",
      image: "unfolded",
    },
    {
      label: translator("modulesStatesShort.unfolded"),
      status: isOutOfTimeChrono ? "completed" : "pending",
      image: "valid",
    },
  ];

  const CLOSE = (): StepperStep[] => [
    {
      label: translator("action.close"),
      status: isOutOfTimeChrono ? "completed" : "active",
      image: "up",
    },
    {
      label: translator("action.down"),
      status: "pending",
      image: "folded",
    },
    {
      label: translator("modulesStatesShort.unfolded"),
      status: "pending",
      image: "valid",
    },
  ];

  const DOWN = (): StepperStep[] => [
    {
      label: translator("action.close"),
      status: "completed",
      image: "up",
    },
    {
      label: translator("action.down"),
      status: isOutOfTimeChrono ? "completed" : "active",
      image: "folded",
    },
    {
      label: translator("modulesStatesShort.folded"),
      status: isOutOfTimeChrono ? "completed" : "pending",
      image: "valid",
    },
  ];

  switch (currentAction) {
    case ModuleCommandEnum.UP:
      result.push(...UP());
      break;
    case ModuleCommandEnum.OPEN:
      result.push(...OPEN());
      break;
    case ModuleCommandEnum.CLOSE:
      result.push(...CLOSE());
      break;
    case ModuleCommandEnum.DOWN:
      result.push(...DOWN());
      break;
  }

  if (result.length === 0) {
    throw new Error("No stepper found");
  }

  return result as StepperStep[];
};
